import { Component, ElementRef, ViewChild } from '@angular/core';
import { DialogContentBase } from '@progress/kendo-angular-dialog';
import { ProductLicense } from 'src/app/admin/system-configuration/shared/models/product-license';

@Component({
  selector: 'app-licensing-permission-popup',
  templateUrl: './licensing-permission-popup.component.html',
  styleUrls: ['./licensing-permission-popup.component.scss']
})
export class LicensingPermissionPopupComponent extends DialogContentBase {

  public productLicense?: ProductLicense;
  public selectedProductLicense?: ProductLicense;

  @ViewChild('popupModal') public modal?: ElementRef;

  public close() {
    this.dialog.close();
  }
}
